import { IProjectPermissions } from "models/permissions.models";

// Each newly added default permission value should be set to false.

export const DEFAULT_PROJECT_PERMISSIONS: IProjectPermissions = {
  canAssignUserAccountToProject: false,
  canAssignUserAccountRoleType: false,
  canEditProjectMembers: false,
  canChangeProjectMembersStatus: false,
  canCreateNewProject: false,
  canChangeProjectStatus: false,
  canEditHADecisionData: false,
  canEditProjectInformation: false,
  canEditParticipationType: false,

  // ----------- Content Creation and Management -----------
  canViewContent: false,
  canUploadContent: false,
  canManageStructuredDocument: false,
  canReorderStructuredDocument: false,
  canReadStructuredTemplate: false,
  canManageStructuredTemplate: false,
  canEditContent: false,
  canEditContentName: false,
  canEditOwnedContentName: false,
  canEditContentMetadata: false,
  canEditOwnedContentMetadata: false,
  canSendContentToTenancy: false,
  canSendCopyToSponsor: false,
  canDeleteContentToTenancy: false,
  canDeleteOwnedContent: false,

  // ----------- Health Authority Questions -----------
  canDeleteQuestion: false,
  canDeleteOwnQuestion: false,
  canCreateQuestion: false,
  canEditOwnedQuestion: false,
  canEditQuestion: false,
  canEditQuestionResponse: false,
  canChangeOwnedQuestionStatus: false,
  canChangeQuestionDueDate: false,
  canChangeQuestionStatus: false,
  canChangeQuestionResponseStatus: false,
  canImportReferenceOrExternalQuestion: false,
  canEditReferenceOrExternalQuestion: false,
  canChangeReferenceOrExternalQuestionStatus: false,
  canSendCopyQuestion: false,
  canSubmitQuestionResponse: false,
  canSubmitReferenceOrExternalQuestion: false,
  canExportQuestionAndResponse: false,
  canCreateOwnedCommentsAsset: false,
  canCreateComments: false,
  canResolveComments: false,

  // ----------- Project Tasks -----------
  canCreateTask: false,
  canCompleteTask: false,
  canViewAssignToAllParentTask: false,
  canBeAssignedToTask: false,
  canManageOwnTask: false,
  canManageTask: false,

  // ----------- Workflow Management -----------
  canChangeOwnedContentStatus: false,
  canChangeContentStatus: false,

  // ----------- Invitations -----------
  // These 2 permissions will be removed once we fully switch to invitation creation via the asset service
  canSendHAInvitation: false,
  canManageProjectInvitations: false,

  // ----------- Invitations -----------
  canCreateProjectInvitations: false,

  // ----------- Milestones -----------
  canManageMilestones: false,

  // ----------- Inline Comments -----------
  canCreatePrivateInlineComment: false,
  canCreatePeerInlineComment: false,
  canCreatePublicInlineComment: false,
  canResolveOwnInlineComments: false,
  canResolveOthersInlineComments: false,
} as const;
